export function inAppBrowser() {
  if (typeof navigator === 'undefined') return false;

  const ua = (navigator.userAgent || navigator.vendor || '').toLowerCase();

  return (
    ua.includes('instagram') ||
    ua.includes('facebook') ||
    ua.includes('fban') ||
    ua.includes('fbav') ||
    ua.includes('twitter') ||
    ua.includes('wechat') ||
    ua.includes('pinterest') ||
    ua.includes('tiktok') ||
    ua.includes('reddit') ||
    ua.includes('discord')
  );
}
